/**
 * Represents all possible label statuses
 */
const LabelStatuses = {
    PRISTINE: 0x00000001,
    CONFIGURED: 0x00000002,
    STARTING: 0x00000004,
    LOGGING: 0x00000008,
    STOPPED: 0x00000010,
    TEMPERATURE_TOO_HIGH: 0x00000020,
    TEMPERATURE_TOO_LOW: 0x00000040,
    BOD: 0x00000080,
    FULL: 0x00000100,
    EXPIRED: 0x00000200,
    I2C_ERROR: 0x00000400,
    SPI_ERROR: 0x00000800,
    SHOCK: 0x00001000,
    SHAKE: 0x00002000,
    VIBRATION: 0x00004000,
    TILT: 0x00008000,
    SHOCK_CONFIGURED: 0x00010000,
    SHAKE_CONFIGURED: 0x00020000,
    VIBRATION_CONFIGURED: 0x00040000,
    TILT_CONFIGURED: 0x00080000,
    HUMIDITY_CONFIGURED: 0x00100000,
    HUMIDITY_TOO_HIGH: 0x00200000,
    HUMIDITY_TOO_LOW: 0x00400000,
    UNEXPECTED_STOP: 0x00800000
};
export { LabelStatuses };
